(function () {
  // Some Shopify apps (e.g. countdown-timer bars) inject a position:fixed element
  // at the top of the viewport with a z-index higher than the menu drawer. The
  // drawer (also position:fixed; top:0) then has its first item obscured by that
  // bar. Detect such bars and expose their height as a CSS variable so the drawer
  // can offset itself below them. Defensive by design: if no such bar exists the
  // offset is 0 and the drawer behaves as before.

  var THEME_FIXED_SELECTORS = ['#header-group', '.menu-drawer', '.menu-drawer__backdrop'];

  function isThemeElement(el) {
    return THEME_FIXED_SELECTORS.some(function (sel) {
      return el.matches && el.matches(sel);
    }) || el.closest && el.closest('#header-group');
  }

  function detect() {
    var maxOffset = 0;
    var candidates = document.querySelectorAll('body > *');

    for (var i = 0; i < candidates.length; i++) {
      var el = candidates[i];
      if (isThemeElement(el)) continue;

      var cs = window.getComputedStyle(el);
      if (cs.position !== 'fixed') continue;
      if (cs.visibility === 'hidden' || cs.display === 'none') continue;
      var top = parseFloat(cs.top);
      if (isNaN(top) || top > 5) continue; // not pinned to (near) the top

      var rect = el.getBoundingClientRect();
      // Real countdown/announcement bars are short and full-width.
      if (rect.height >= 20 && rect.height <= 200 && rect.width >= window.innerWidth * 0.5) {
        if (rect.height > maxOffset) maxOffset = rect.height;
      }
    }

    var current = document.documentElement.style.getPropertyValue('--countdown-bar-offset');
    var next = maxOffset + 'px';
    if (current.trim() !== next) {
      document.documentElement.style.setProperty('--countdown-bar-offset', next);
    }
  }

  function scheduleDetect() {
    detect();
    // App-embed iframes/scripts can land late — re-check a few times.
    setTimeout(detect, 500);
    setTimeout(detect, 1500);
    setTimeout(detect, 3000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleDetect);
  } else {
    scheduleDetect();
  }
  window.addEventListener('load', scheduleDetect);

  // Catch app embeds that inject content after load.
  if ('MutationObserver' in window) {
    var observer = new MutationObserver(function () {
      detect();
    });
    document.addEventListener('DOMContentLoaded', function () {
      observer.observe(document.body, { childList: true, subtree: false });
    });
  }
})();
